function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#fff",
  strokeWidth: 0.4,
  d: "M16.575 4.8c-.524-.2-1.111.062-1.311.586-.2.524.062 1.111.586 1.312 3.59 1.373 6.072 4.833 6.072 8.825 0 5.209-4.237 9.446-9.445 9.446-5.209 0-9.446-4.238-9.446-9.446 0-3.994 2.484-7.453 6.072-8.825.524-.2.786-.788.586-1.312-.2-.523-.788-.786-1.311-.585C4.005 6.473 1 10.684 1 15.523 1 21.867 6.133 27 12.477 27c6.343 0 11.476-5.134 11.476-11.477 0-4.842-3.007-9.051-7.378-10.722z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#fff",
  strokeWidth: 0.4,
  d: "M12.477 1c-.561 0-1.016.455-1.016 1.016v9.945c0 .561.455 1.016 1.016 1.016.56 0 1.015-.455 1.015-1.016V2.016c0-.561-.455-1.016-1.015-1.016z"
});

function SvgFrame15(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 28,
    fill: "none",
    viewBox: "0 0 25 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame15);
export default __webpack_public_path__ + "static/media/Frame 15.168313ec.svg";
export { ForwardRef as ReactComponent };